import * as React from 'react'
import { Button, FilterContext } from '@teamsnap/teamsnap-ui'

type Props = {
  show: boolean
  activeFilters: object
  setActiveFilters: (x: object) => any
  filters: any
}

const CalendarFilters = ({ show, activeFilters, setActiveFilters, filters }: Props) => {
  const filtersSection = (
    <>
      <div className="u-size7of8">
        {filters.map((Item, index) => (
          <Item key={index} isLast={index === filters.length - 1} />
        ))}
      </div>
      <div className="u-size1of8 u-textRight u-spaceRightMd">
        <Button
          type="text"
          onClick={() => {
            setActiveFilters({})
          }}
        >
          Clear All
        </Button>
      </div>
    </>
  )


  return (
    <FilterContext.Provider value={{ activeFilters, setActiveFilters }}>
      <div className={`Panel u-padSm u-spaceTopSm u-borderNeutral4 u-bgNeutral1 Grid-cell ${show ? 'u-flex' : 'u-hidden'}`} >
        {filtersSection}
      </div>
    </FilterContext.Provider>
  )

}

export default CalendarFilters
